export default __webpack_public_path__ + "static/brief-web-66acef9a6a637dffeb0a877abd584cdf.pdf";